import { render } from "./CertificatesForm.vue?vue&type=template&id=52b6fc50"
import script from "./CertificatesForm.vue?vue&type=script&lang=js"
export * from "./CertificatesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__